import { Button, Grid, NetworkIcon, Spinner, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { Trans, useTranslation } from 'react-i18next'
import { Redirect, useHistory } from 'react-router'
import { useParams } from 'react-router-dom'
import styles from 'modules/Billing/Billing.module.scss'
import BillingForm from 'modules/Forms/Billing/BillingForm'
import AdmitadWarning from 'modules/Billing/subcomponents/AdmitadWarning'
import Placeholder from 'modules/Billing/subcomponents/Placeholder'
import PaymentMethods from 'modules/Billing/subcomponents/PaymentMethods'
import { useBilling } from 'modules/Forms/Billing/useBilling'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import Billing from 'modules/Forms/Billing/hoc/Billing'
import { IS_APP_PRODUCT_GETUNIQ } from 'utils/constants/product'
import Notification from 'modules/Billing/subcomponents/Notification'
import HighRiskLabel from 'modules/Services/Network/subcomponents/HighRiskLabel'
import { TOGGLE_PANEL } from 'modules/Tickets/types'
import { useDispatch } from 'react-redux'
import PageHeader from 'components/PageHeader'

const AccountReplenish = () => {
  const dispatch = useDispatch()
  const {
    data: {
      methods: { loading, loaded, data: methods = [] } = {},
      activeMethod,
      networkAccountData: {
        status,
        loaded: accountLoaded,
        login: accountName = '',
        type = null,
      } = {},
    } = {},
    setActiveMethod,
    getPaymentMethods,
    getNetworkAccountData,
    getAccountData,
    pushMethods,
  } = useBilling('accounts-billing')
  const history = useHistory()
  const pathGen = useGeneratePathI18n()
  const { accountId } = useParams()

  const { t } = useTranslation(['billing'])

  useEffect(() => {
    getNetworkAccountData({ accountId })
  }, [])

  useEffect(() => {
    if (activeMethod?.method === 'admitad') {
      getAccountData({ id: activeMethod.method })
    }
  }, [activeMethod])

  useEffect(() => {
    if (accountId && accountLoaded) {
      getPaymentMethods({ accountId })
    }
  }, [accountId, accountLoaded])

  useEffect(
    () => loaded && IS_APP_PRODUCT_GETUNIQ && pushMethods([{ method: 'admitad' }]),
    [loaded],
  )

  if (status === 404) {
    return <Redirect to={pathGen(ROUTES.SERVICES)} />
  }

  return (
    <>
      <Helmet defer={false}>
        <title>{t('head.account.title', { accountName })}</title>
      </Helmet>
      <Billing>
        {!loaded ? (
          <div className={'layout-tile'}>
            <Placeholder />
          </div>
        ) : (
          <>
            <div className={styles['billing__content-top']}>
              <Notification />

              <Grid
                direction={'column'}
                gap={24}
                className={'layout-tile margin-bottom-16'}
              >
                <PageHeader>{t('balance_replenishment_account')}</PageHeader>
                <Grid
                  direction={'column'}
                  gap={8}
                >
                  <Typography
                    variant={'Body-10'}
                    color={'Label-Secondary'}
                    noMargin
                  >
                    {t('account_login')}
                  </Typography>
                  <Grid
                    gap={8}
                    alignItems={'center'}
                    fluid={false}
                    wrap={false}
                  >
                    <NetworkIcon
                      rounded
                      name={type}
                      size={'xs'}
                    />
                    <Typography
                      component={'div'}
                      variant={'Body-3'}
                      color={'Label-Fifth'}
                      noMargin
                    >
                      {accountName}
                    </Typography>
                    {type?.match(/high-risk$/) && <HighRiskLabel size={'xs'} />}
                  </Grid>
                </Grid>
              </Grid>

              {loading && (
                <div className={styles['billing__spinner']}>
                  <Spinner color="Label-GU-Primary" />
                </div>
              )}

              <Grid
                gap={16}
                className={'margin-bottom-16'}
              >
                {loaded && (
                  <PaymentMethods
                    activeMethod={activeMethod}
                    className={'layout-tile'}
                    handleClickSlider={setActiveMethod}
                    methods={methods}
                  />
                )}
              </Grid>

              {activeMethod?.method === 'admitad' ? (
                <AdmitadWarning />
              ) : (
                <div className={'layout-tile'}>
                  <BillingForm
                    accountId={accountId}
                    onClose={() => {
                      history.push(
                        pathGen(ROUTES.SERVICES_NETWORK_ACCOUNT, {
                          networkType: type,
                          accountId,
                        }),
                      )
                    }}
                  />
                </div>
              )}
            </div>
            <div className={'padding-16'}>
              <Typography
                variant={'Body-Forms-20'}
                color={'Label-Secondary'}
              >
                <Trans i18nKey={'billing::info'}>
                  Средства поступают на ваш баланс сразу. В редких случаях перевод может занять до
                  24 часов. При возникновении проблем обратитесь в
                  <Button
                    color={'Label-GU-Primary'}
                    component={'span'}
                    variant={'link'}
                    onClick={() => dispatch({ type: TOGGLE_PANEL, payload: true })}
                  >
                    тикеты
                  </Button>
                </Trans>
              </Typography>
            </div>
          </>
        )}
      </Billing>
    </>
  )
}
AccountReplenish.propTypes = {
  onClose: PropTypes.func,
}
export default AccountReplenish
